// FullBlog.jsx (public view)
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import './fullblog.css';

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'https://api.mitadtu.in';

const FullBlog = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const paragraphs = blog?.message?.split("\n") || [];


  useEffect(() => {
    const fetchBlog = async () => {
      const res = await fetch(`${API_BASE}/api/admin/manet-blogs/public/${id}`);
      const data = await res.json();
      if (data.success) setBlog(data.data);
    };
    fetchBlog();
  }, [id]);

  if (!blog) return <p>Loading...</p>;

  return (
    <div>
      <h1 className="title">Manet Blogs</h1>
      <hr />
      <div className="full-blog-page">

        <div className="blog-top">
          <h3 className="innerpage-heading">{blog.title}</h3>
          <h2 className="blog-subtitle">
            By {blog.blog_by}
            {blog.blog_date && ` | ${new Date(blog.blog_date).toLocaleDateString()}`}
          </h2>



        </div>

        <div className="blog-container">
          <div className="blog-top">
            {blog.blog_image && (
              <img
                className="blog-image"
                src={`${API_BASE}${blog.blog_image}`}
                alt={blog.title}
              />
            )}

            <div className="blog-side-text">
              {paragraphs.slice(0, 2).map((para, index) => (
                <p key={index}>{para}</p>
              ))}
            </div>
          </div>

          <div className="blog-bottom-text">
            {paragraphs.slice(2).map((para, index) => (
              <p key={index}>{para}</p>
            ))}
          </div>

          <Link className="blog-link" to="/lifeatcampus/manet-blogs">
            ← Back to Blogs
          </Link>

        </div>
      </div>
    </div >
  );
};

export default FullBlog;
